import React, {useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Header as ElproHeader} from './Header';
import {Sidebar} from './Sidebar';
import UserIdle from '../Infrastructure/UserIdle/UserIdle';
import pubsub from 'pubsub-js';
import {AccessContext} from '../Infrastructure/Authorization/Context/AccessContext';
import {layoutPermissions} from '../Infrastructure/Authorization/Access';
import {Layout, Modal} from 'antd';

import styles from './styles/styles.module.scss';
import WebSockets from '../Infrastructure/WebSockets/WebSocket';
import UserSettings from '../Infrastructure/Settings/UserSettings';
import {GetSystemInformation} from '../../common/services/WebserverServicePro/SystemInformationService';
import {IStatusInformationResponse} from '@elproag/webserver-service-pro';

const {Header, Content, Sider} = Layout;

export function Base(props: {children: React.JSX.Element | React.JSX.Element[]}): React.JSX.Element[] | React.JSX.Element {
	const accessContext = useContext(AccessContext);
	const history = useHistory();
	const showSidebar = userMayNavigate();
	const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
	const sessionExpiredSubscription = pubsub.subscribe('sessionExpired', () => history.push('/login'));
	const [isSystemInfoModalOpen, setIsSystemInfoModalOpen] = useState<boolean>(false);
	const [systemInfo, setSystemInfo] = useState<IStatusInformationResponse>();

	WebSockets.init();
	UserSettings.decodeJwt();

	const handleOk = () => {
		if (systemInfo?.id) {
			localStorage.setItem('systemInfoModalDismissed', systemInfo.id.toString());
		}
		setIsSystemInfoModalOpen(false);
	};

	useEffect(() => {
		GetSystemInformation()
			.then(info => {
				setSystemInfo(info);
				const dismissed = localStorage.getItem('systemInfoModalDismissed') === info?.id?.toString();
				setIsSystemInfoModalOpen(!!info?.id && !dismissed);
			})
			.catch(() => {
				setSystemInfo(undefined);
				setIsSystemInfoModalOpen(false);
			});
	}, []);

	useEffect(() => {
		return () => {
			pubsub.unsubscribe(sessionExpiredSubscription);
		};
	});

	function userMayNavigate(): boolean {
		if (accessContext.user && accessContext.user.access_settings.layout) {
			const {navigation} = accessContext.user.access_settings.layout;
			return navigation[layoutPermissions.navigation.navigation.key];
		}

		return true;
	}

	function getContentMargin(): string {
		if (!showSidebar) {
			return '0';
		}
		if (sidebarCollapsed) {
			return '80px';
		}
		return '200px';
	}

	return (
		<Layout className={styles.layout}>
			<Header className={styles.header}>
				<ElproHeader />
			</Header>
			<Layout>
				{showSidebar && (
					<Sider
						breakpoint={'md'}
						collapsible={true}
						collapsed={sidebarCollapsed}
						onCollapse={value => setSidebarCollapsed(value)}
						className={styles.sider}
					>
						<Sidebar collapsed={sidebarCollapsed} />
					</Sider>
				)}
				<Content style={{marginLeft: getContentMargin()}} className={styles.content}>
					<Modal
						title="System Information"
						open={isSystemInfoModalOpen}
						onOk={handleOk}
						onCancel={() => setIsSystemInfoModalOpen(false)}
						centered
						okText="Dismiss"
						cancelText="Close"
						width={{
							xs: '90%',
							sm: '80%',
							md: '70%',
							lg: '60%',
							xl: '50%',
							xxl: '40%',
						}}
					>
						<p style={{whiteSpace: 'pre-wrap'}}>{systemInfo?.notificationMessage}</p>
					</Modal>
					<UserIdle />
					{props.children}
				</Content>
			</Layout>
		</Layout>
	);
}

export default Base;
